import * as qs from '@/ui/queryState';
import { IssuePriority, IssueType } from '@/entities/issue';
import { IssueStatus } from '@/entities/todo';
import { endsToday, startsLast30Days } from '@/ui/helpers/dateHelper';

export const useQueryFiltering = () => ({
  start: qs.date('start', startsLast30Days()),
  end: qs.date('end', endsToday()),
  creator: qs.numbers('creator', []),
  assignee: qs.numbers('assignee', []),
  resolver: qs.numbers('resolver', []),
  question: qs.strings('question', []),
  entityItem: qs.numbers('entityItem', []),
  entityFolder: qs.strings('entityFolder', []),
  group: qs.numbers('group', []),
  category: qs.numbers('category', []),
  checklist: qs.numbers('checklist', []),
  section: qs.strings('section', []),
  inspection: qs.numbers('inspection', []),
  sensor: qs.numbers('sensor', []),
  questionTitle: qs.strings('questionTitle', []),
  response: qs.strings('response', []),
  status: qs.numericEnums<IssueStatus>('status', Object.values(IssueStatus) as IssueStatus[], []),
  type: qs.stringEnums<IssueType>('type', Object.values(IssueType), []),
  priority: qs.numericEnums<IssuePriority>('priority', Object.values(IssuePriority) as IssuePriority[], []),
  overdue: qs.boolean('overdue', false),
});
